export const DEALER_INFO = ["FO", "subject", "city", "INN", "code"];
export const LOCALIZE_DEALER_INFO = ["FO", "subject", "city"];
export const RATINGS_TYPES = {
  gr: "GR",
  q: "Q",
  staff: "staff",
  zd: "zd",
};
